import updateBlockMetadata from '../../customRichUtils/blocks/updateBlockMetadata';

export default (getEditorState, setEditorState) => (block, metadata) => {
    const editorState = getEditorState();
    const newEditorState = updateBlockMetadata(editorState, block, metadata);
    setEditorState(newEditorState);
};
